// Shared constants used across Chat, Grammar, and TaskReview components.

export const LANG_LABEL: Record<string, string> = {
  english: 'inglés',
  german:  'alemán',
  french:  'francés',
};

export const TARGET_LANG: Record<string, string> = {
  english: 'EN-US',
  german:  'DE',
  french:  'FR',
};

export const TRANSLATOR_INSTRUCTION: Record<string, string> = {
  english: 'Please type your answer in Spanish and we will translate it to English for you.',
  german:  'Bitte schreibe deine Antwort auf Spanisch und wir übersetzen sie für dich ins Deutsche.',
  french:  'Veuillez écrire votre réponse en espagnol et nous la traduirons en français pour vous.',
};
